import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPencil = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M18.796 0c-1.38 0-2.704.548-3.68 1.524l-1.404 1.404-.002.002-.002.002L.36 16.28c-.23.23-.36.543-.36.87v5.62C0 23.45.55 24 1.23 24h5.62c.327 0 .64-.13.87-.36l13.35-13.35 1.406-1.406A5.204 5.204 0 0 0 18.796 0ZM20.2 7.681l.536-.536a2.745 2.745 0 1 0-3.882-3.882l-.536.536L20.2 7.681Zm-5.62-2.143 3.882 3.882-12.12 12.12H2.458v-3.88L14.58 5.538Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPencil);
export default ForwardRef;
